export default {"src":"/_next/static/media/ETH.39c1187b.svg","height":56,"width":36,"blurWidth":0,"blurHeight":0};